module.exports = __webpack_public_path__ + "static/media/unionIcon.fcba3d84.svg";